
<privcatsearch privcat="" privcatref="" hideaddoption="true" onselectcb="">


<div class="row">
  <div class="col-xs-3 col-md-1">Stk</div>
  <div class="col-xs-9 col-md-9">Bezeichnung</div>
  <div class="col-xs-6 col-md-1">Brutto</div>
  <div class="col-xs-6 col-md-1">Steuer</div>
</div>


<div class="row" ng-repeat="item in vm.cart.items">
  <div class="col-xs-3 col-md-1">{{item.quantity}}</div>
  <div class="col-xs-9 col-md-9">{{item.name}}</div>
  <div class="col-xs-6 col-md-1">&euro; {{item.price}}</div>
  <div class="col-xs-6 col-md-1">{{item.tax}}%</div>
</div>
